/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
	Box, Typography, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress,
	Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Collapse, Avatar, AppBar, Toolbar, Divider, TextField, MenuItem, Select, FormControl, InputLabel, Dialog, DialogTitle, DialogContent, DialogActions,
	IconButton, Chip, Alert, Badge
} from '@mui/material';
import {
	Home as HomeIcon, Payment as PaymentIcon, Inventory as InventoryIcon,
	EventNote as EventNoteIcon, History as HistoryIcon, Inbox as InboxIcon, Assignment as AssignmentIcon, ExpandLess, ExpandMore, Logout as LogoutIcon, ChevronLeft as ChevronLeftIcon, ChevronRight as ChevronRightIcon, Menu as MenuIcon
} from '@mui/icons-material';
import WebcamCapture from './components/WebcamCapture';
import { formatTime12h, formatDateTimeToTime12h, formatDateOnly, toDateKey, getCurrentDateKey } from './utils/dateTimeUtils';
import { formatDatePH, formatDateTimePH } from './utils/dateFormat';
import PayslipCard from './components/PayslipCard';
import LeaveRequestForm from './components/Leave/LeaveRequestForm';
import LeaveBalancesSummary from './components/Leave/LeaveBalancesSummary';
import LeaveRequestsTable from './components/Leave/LeaveRequestsTable';
import InboxPanel from './components/InboxPanel';
import SidebarNavItem from './components/Layout/SidebarNavItem';
import PersonalCalendar from './components/Calendar/PersonalCalendar';
import MyProfileDialog from './components/common/MyProfileDialog';
import LiveDateTimeWidget from './components/LiveDateTimeWidget';
import { formatName } from './utils/formatName';
import { fetchPayslipRow } from './utils/payslipApi';
import { API_BASE } from './utils/apiBase';

const INVENTORY_WARNING_STOCK_THRESHOLD = 70;
const INVENTORY_CRITICAL_STOCK_THRESHOLD = 30;
const getInventoryStockLevel = (quantity) => {
	const qty = Number(quantity || 0);
	if (qty < INVENTORY_CRITICAL_STOCK_THRESHOLD) return 'critical';
	if (qty <= INVENTORY_WARNING_STOCK_THRESHOLD) return 'warning';
	return 'ok';
};

// Unified Custodian dashboard matching Employee layout with Custodian features preserved
export default function CustodianDashboardNew({ user, onLogout }) {
	const normalizedRole = (user?.role || '').toLowerCase();
	const fullDisplayName = formatName(user, { lastFirst: false, middle: 'full', capitalize: true }) || user?.username || '';
	const [activeSection, setActiveSection] = useState('home');
	const navigate = useNavigate();
	const location = useLocation();
	const basePath = '/dashboard/custodian';
	const [attendance, setAttendance] = useState([]);
	const [loading, setLoading] = useState(false);
	const [busy, setBusy] = useState(false);
	const [mobileOpen, setMobileOpen] = useState(false);
	const [message, setMessage] = useState('');
	const [profileOpen, setProfileOpen] = useState(false);
	const [manualReason, setManualReason] = useState('');
	const [pendingManualRequest, setPendingManualRequest] = useState(null);
	const [, setLastManualFeedback] = useState(null);
	const [manualLoading, setManualLoading] = useState(false);
	const [manualReasonDialogOpen, setManualReasonDialogOpen] = useState(false);
	const [manualReasonDraft, setManualReasonDraft] = useState('');
	const [manualEvidenceFile, setManualEvidenceFile] = useState(null);
	const [dtrEvidenceFile, setDtrEvidenceFile] = useState(null);
	const [dtrEvidenceNotes, setDtrEvidenceNotes] = useState('');
	const [dtrEvidenceRows, setDtrEvidenceRows] = useState([]);
	const [dtrEvidenceLoading, setDtrEvidenceLoading] = useState(false);
	const [timeOutDialogOpen, setTimeOutDialogOpen] = useState(false);
	const [faceServiceOfflineUntil, setFaceServiceOfflineUntil] = useState(0);
	const [faceServiceWarned, setFaceServiceWarned] = useState(false);
	const [cameraAvailability, setCameraAvailability] = useState('checking');
	const [manualFallbackState, setManualFallbackState] = useState({ eligible: false, reason: '', failedAttempts: 0 });

	// camera refs/state (preserve existing logic)
	const videoRef = useRef(null);
	const canvasRef = useRef(null);
	const streamRef = useRef(null);
	const [cameraOn, setCameraOn] = useState(false);
	const [, setRecognitionOpen] = useState(false);
	const [recognizedCandidate, setRecognizedCandidate] = useState(null);

	// payroll
	const [, setPayrollRows] = useState([]);
	const [payrollLoading, setPayrollLoading] = useState(false);
  const [payrollError, setPayrollError] = useState('');
	const [payslip, setPayslip] = useState(null);
	const [selectedMonth, setSelectedMonth] = useState(() => new Date().getMonth() + 1);
	const [selectedYear, setSelectedYear] = useState(() => new Date().getFullYear());
	const [personalPayrollCutoffs, setPersonalPayrollCutoffs] = useState([]);
	const [selectedPayslipCutoffId, setSelectedPayslipCutoffId] = useState('');
  const [, setPayrollPreview] = useState(null);
  const [, setPayrollPreviewOpen] = useState(false);
	// Track if the current user has an open shift (time-in with no time-out yet)
	const [hasOpenShift, setHasOpenShift] = useState(false);
	const [hasPendingManualShift, setHasPendingManualShift] = useState(false);
	const [isOnBreak, setIsOnBreak] = useState(false);
	const [openShiftRecord, setOpenShiftRecord] = useState(null);
	const [breakCountdownMs, setBreakCountdownMs] = useState(0);
	const [unreadInboxCount, setUnreadInboxCount] = useState(0);
	const [profilePhotoId, setProfilePhotoId] = useState(null);

	const getLocalSqlNow = () => {
		const now = new Date();
		const y = now.getFullYear();
		const m = String(now.getMonth() + 1).padStart(2, '0');
		const d = String(now.getDate()).padStart(2, '0');
		const hh = String(now.getHours()).padStart(2, '0');
		const mm = String(now.getMinutes()).padStart(2, '0');
		const ss = String(now.getSeconds()).padStart(2, '0');
		return { date: `${y}-${m}-${d}`, time: `${hh}:${mm}:${ss}` };
	};

	const buildAttendanceDateTime = React.useCallback((dateValue, timeValue) => {
		const dateKey = toDateKey(dateValue || new Date());
		const timePart = String(timeValue || '').trim();
		if (!dateKey || !timePart) return null;
		const parsed = new Date(`${dateKey}T${timePart}+08:00`);
		return Number.isNaN(parsed.getTime()) ? null : parsed;
	}, []);

	const formatCountdownLabel = (remainingMs) => {
		const clamped = Math.max(0, Number(remainingMs || 0));
		const totalSeconds = Math.floor(clamped / 1000);
		const hours = Math.floor(totalSeconds / 3600);
		const minutes = Math.floor((totalSeconds % 3600) / 60);
		const seconds = totalSeconds % 60;
		if (hours > 0) {
			return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
		}
		return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
	};

	const getStatusChip = (statusLabel) => {
		const s = String(statusLabel || '').toLowerCase();
		let sx = { fontWeight: 700 };
		if (s.includes('pending')) sx = { ...sx, bgcolor: '#f57c00', color: '#fff' };
		else if (s.includes('present')) sx = { ...sx, bgcolor: '#2e7d32', color: '#fff' };
		else if (s.includes('half day')) sx = { ...sx, bgcolor: '#8b5cf6', color: '#fff' };
		else if (s.includes('late')) sx = { ...sx, bgcolor: '#fbc02d', color: '#1f2937' };
		else if (s === 'absent') sx = { ...sx, bgcolor: '#d32f2f', color: '#fff' };
		else if (s === 'leave') sx = { ...sx, bgcolor: '#1976d2', color: '#fff' };
		else sx = { ...sx, bgcolor: '#64748b', color: '#fff' };
		return <Chip size="small" label={statusLabel || '-'} sx={sx} />;
	};

	const getAttendanceMethod = (row) => {
		const explicitMethod = String(row?.attendance_method_label || '').trim();
		if (explicitMethod) return explicitMethod;
		const manualStatus = String(row?.manual_request_status || '').toLowerCase();
		if (manualStatus === 'pending') return 'Manual Review';
		if (manualStatus === 'approved' || manualStatus === 'rejected') return 'Manual';
		if (row?.face_recognized === 1 || row?.face_recognized === true) return 'Face';
		if (row?.log_time || row?.time_out) return 'No Face';
		if (row?.leave_approved) return 'System';
		return '-';
	};

	const getAttendanceStatusLabel = (row) => {
		const lateMinutes = Number(row?.late_minutes || row?.lateMinutes || 0) || 0;
		const lateLabel = lateMinutes > 0 ? `Late (${lateMinutes} min)` : 'Late';
		const explicitStatus = String(row?.attendance_status_label || '').trim();
		if (explicitStatus.toLowerCase().includes('late')) return lateLabel;
		if (explicitStatus) return explicitStatus;
		const manualStatus = String(row?.manual_request_status || '').toLowerCase();
		const manualResolution = String(row?.manual_request_resolution || '').toLowerCase();
		if (manualStatus === 'pending') return 'Pending Manual Review';
		if (manualStatus === 'approved') return 'Present';
		if (manualStatus === 'rejected' && manualResolution === 'late') return lateLabel;
		if (manualStatus === 'rejected' && manualResolution === 'absent') return 'Absent';
		if (row?.is_absent === 1 || row?.is_absent === true) return 'Absent';
		if (row?.leave_approved === 1 || row?.leave_approved === true) return 'Leave';
		if (row?.half_day === 1 || row?.half_day === true) return 'Half Day';
		if (lateMinutes > 0 || row?.late === 1 || row?.late === true || row?.late === '1') return lateLabel;
		if (row?.log_time) {
			return (row?.face_recognized === 1 || row?.face_recognized === true) ? 'Present (Face)' : 'Present (No Face)';
		}
		return '-';
	};

	const getManualFallbackReasonLabel = (reason) => {
		const normalized = String(reason || '').trim().toLowerCase();
		if (normalized === 'not_recognized') return 'Not recognized';
		if (normalized === 'wrong_employee') return 'Wrong employee';
		if (normalized === 'no_face') return 'No face detected';
		if (normalized === 'service_offline') return 'Face service unavailable';
		if (normalized === 'recognition_error' || normalized === 'recognition_failed') return 'Recognition failed';
		return 'Face recognition issue';
	};

	const timeInLocked = hasOpenShift || hasPendingManualShift;
	const manualAttendanceAllowed = cameraAvailability === 'unavailable' || manualFallbackState.eligible;

	const employmentStart = React.useMemo(() => {
		const raw = user?.date_hired || user?.dateHired || null;
		if (!raw) return null;
		const d = new Date(raw);
		if (Number.isNaN(d.getTime())) return null;
		return new Date(d.getFullYear(), d.getMonth(), 1);
	}, [user?.date_hired, user?.dateHired]);

	const nowRef = new Date();
	const currentMonth = nowRef.getMonth() + 1;
	const currentYear = nowRef.getFullYear();
	const minYear = employmentStart ? employmentStart.getFullYear() : (currentYear - 3);
	const minMonth = employmentStart ? (employmentStart.getMonth() + 1) : 1;

	const getMonthBoundsForYear = React.useCallback((year) => {
		let start = 1;
		let end = 12;
		if (year === minYear) start = minMonth;
		if (year === currentYear) end = currentMonth;
		if (start > end) start = end;
		return { start, end };
	}, [minYear, minMonth, currentYear, currentMonth]);

	const availableYears = React.useMemo(() => {
		const years = [];
		for (let y = minYear; y <= currentYear; y += 1) years.push(y);
		return years.length > 0 ? years : [currentYear];
	}, [minYear, currentYear]);

	useEffect(() => {
		const y = Number(selectedYear);
		const m = Number(selectedMonth);
		const clampedYear = Math.min(Math.max(y, minYear), currentYear);
		const bounds = getMonthBoundsForYear(clampedYear);
		const clampedMonth = Math.min(Math.max(m, bounds.start), bounds.end);
		if (clampedYear !== y) setSelectedYear(clampedYear);
		if (clampedMonth !== m) setSelectedMonth(clampedMonth);
	}, [selectedYear, selectedMonth, minYear, currentYear, getMonthBoundsForYear]);

	// Default inventory items (fall back when server returns none)
	const DEFAULT_INVENTORY_ITEMS = [
		'Broom',
		'Mop',
		'Bucket',
		'Cleaning cloths',
		'Scrubbing brush',
		'Spray bottles',
		'Cleaning sponges',
		'Disinfectant sprayer',
		'Waste bins',
		'Gloves',
		'Face masks',
		'Window scraper',
		'Glass cleaning',
		'Toilet brush',
		'Apron',
		'Cleaning cart'
	];

	// Inventory request
	const [inventoryItems, setInventoryItems] = useState([]);
	const [reqItemId, setReqItemId] = useState('');
	const [reqQty, setReqQty] = useState('1');
	const [reqMessage, setReqMessage] = useState('');
	const [currentDeployment, setCurrentDeployment] = useState(null);
	const [deploymentLoading, setDeploymentLoading] = useState(false);
	const [myRequests, setMyRequests] = useState([]);
	const [loadingRequests, setLoadingRequests] = useState(false);
	const pendingInventoryRequestCount = Array.isArray(myRequests)
		? myRequests.filter((row) => String(row?.status || 'pending').toLowerCase() === 'pending').length
		: 0;
	const [snack, setSnack] = useState({ open: false, message: '', severity: 'info' });
	const lowInventoryItems = React.useMemo(() => {
		return (Array.isArray(inventoryItems) ? inventoryItems : [])
			.map((item) => {
				const quantity = Number(item?.quantity ?? item?.stock ?? item?.qty ?? 0);
				return {
					...item,
					quantity: Number.isFinite(quantity) ? quantity : 0,
					label: item?.item_name || item?.name || item?.item || 'Unnamed item',
				};
			})
			.filter((item) => item.quantity <= INVENTORY_WARNING_STOCK_THRESHOLD)
			.sort((a, b) => a.quantity - b.quantity || String(a.label).localeCompare(String(b.label)))
			.slice(0, 6);
	}, [inventoryItems]);
	const faceServiceOffline = !!(faceServiceOfflineUntil && Date.now() < faceServiceOfflineUntil);
	const triggerFaceServiceOffline = () => {
		setFaceServiceOfflineUntil(Date.now() + 10000);
		if (!faceServiceWarned) {
			setFaceServiceWarned(true);
			setSnack({ open: true, message: 'Face service is offline. Please ask an administrator to start it.', severity: 'warning' });
		}
	};

	useEffect(() => {
		let cancelled = false;
		const loadProfilePhoto = async () => {
			const employeeKey = user?.employeeid || user?.employee_no || user?.id || '';
			if (!employeeKey) {
				setProfilePhotoId(null);
				return;
			}
			try {
				const res = await axios.get(`${API_BASE}/api/photos_blob/list/${employeeKey}`, { withCredentials: true });
				if (cancelled) return;
				const rows = Array.isArray(res?.data?.photos) ? res.data.photos : (Array.isArray(res?.data) ? res.data : []);
				setProfilePhotoId(rows?.[0]?.id || null);
			} catch (e) {
				if (!cancelled) setProfilePhotoId(null);
			}
		};
		loadProfilePhoto();
		return () => { cancelled = true; };
	}, [user?.employeeid, user?.employee_no, user?.id]);

	// Safe helper for user-facing error messages
	const showApiMessage = (error, fallback = 'Something went wrong. Please try again.') => {
		let message = fallback;

		if (error && error.response && error.response.data) {
			const data = error.response.data;
			message = data.message || data.error || fallback;
		} else if (typeof error === 'string') {
			message = error;
		}

		setSnack({
			open: true,
			severity: 'error',
			message
		});
	};

	const toIsoDate = (value) => {
		return toDateKey(value);
	};

	const buildCutoffLabel = (startDate, endDate) => {
		const startLabel = formatDateOnly(startDate);
		const endLabel = formatDateOnly(endDate);

		if (startLabel && endLabel && startLabel !== endLabel) {
			return `${startLabel} – ${endLabel}`;
		}

		return startLabel || endLabel || '';
	};

	const buildPayslipFromHistoryRow = (row) => {
		if (row && row.employee && row.period && row.earnings && row.deductions && row.totals) {
			return row;
		}
		const month = Number(row?.month || 0) || null;
		const year = Number(row?.year || 0) || null;
		const periodStart = (month && year) ? new Date(year, month - 1, 1) : null;
		const periodEnd = (month && year) ? new Date(year, month, 0) : null;
		const basicPay = Number(row?.base_salary || 0);
		const netPay = Number(row?.net_salary || 0);
		const absences = Number(row?.absences || 0);
		const grossPay = Number.isFinite(basicPay) ? basicPay : 0;
		const totalDeductions = Math.max(0, grossPay - (Number.isFinite(netPay) ? netPay : 0));
		const daysInMonth = periodEnd ? periodEnd.getDate() : 0;
		const daysWorked = Math.max(0, daysInMonth - Math.max(0, absences));
		const dailyRate = daysWorked > 0 ? (basicPay / daysWorked) : Number(user?.baseSalary || user?.base_salary || user?.base_salary_per_day || 0);

		// Build full name from user fields, fallback to username
		const fullName = fullDisplayName || user?.username || '';

		return {
			employee: {
				full_name: fullName,
				employee_no: user?.employeeid || user?.employee_no || user?.username || '',
				position_type: normalizedRole ? normalizedRole.charAt(0).toUpperCase() + normalizedRole.slice(1) : ''
			},
			period: {
				start: toIsoDate(periodStart),
				end: toIsoDate(periodEnd),
				cutoff_label: buildCutoffLabel(periodStart, periodEnd)
			},
			earnings: {
				basic_pay: basicPay,
				days_worked: daysWorked,
				daily_rate: Number.isFinite(dailyRate) ? dailyRate : 0,
				overtime_pay: 0,
				holiday_pay: 0,
				allowances: 0,
				gross_pay: grossPay
			},
			deductions: {
				sss: 0,
				philhealth: 0,
				pagibig: 0,
				tax: 0,
				late: 0,
				absences: {
					days: absences,
					amount: 0
				},
				others: 0,
				total_deductions: totalDeductions
			},
			totals: {
				net_pay: Number.isFinite(netPay) ? netPay : grossPay - totalDeductions
			}
		};
	};
	// File leave
	const [allowedLeaveTypes, setAllowedLeaveTypes] = useState([]);
	const [leaveBalances, setLeaveBalances] = useState({});
	const [, setLeaveProfile] = useState({});
	const [myLeaveRequests, setMyLeaveRequests] = useState([]);
	const [myLeaveLoading, setMyLeaveLoading] = useState(false);
	const [myLeaveError, setMyLeaveError] = useState('');
	const handleLeaveMetaLoaded = React.useCallback((meta = {}) => {
		setAllowedLeaveTypes(Array.isArray(meta?.types) ? meta.types : []);
		setLeaveBalances(meta?.balances && typeof meta.balances === 'object' ? meta.balances : {});
		setLeaveProfile(meta?.profile || {});
	}, []);

	const isAttendanceSectionActive = activeSection === 'attendance-cam' || activeSection === 'attendance-record';
	// sidebar attendance expand
	const [attendanceOpen, setAttendanceOpen] = useState(true);

	// fetch attendance records (Attendance Record)
	const fetchAttendance = async () => {
		setLoading(true);
		try {
			const res = await axios.get(`${API_BASE}/api/attendance`, { withCredentials: true });
			const rows = res.data || [];
			setAttendance(rows);

			// Detect if there is any open shift (time_in exists, time_out is null).
			// Do not limit to "today" to avoid date-boundary lock bugs.
			const toLocalIso = (d) => {
				const yr = d.getFullYear();
				const mo = String(d.getMonth() + 1).padStart(2, '0');
				const da = String(d.getDate()).padStart(2, '0');
				return `${yr}-${mo}-${da}`;
			};
			const normalizeDate = (v) => {
				return toDateKey(v);
			};
			const isOpenAttendanceRow = (r) => {
				const manualPending = String(r?.manual_request_status || '').toLowerCase() === 'pending';
				const hasTimeIn = Boolean(r?.log_time || r?.time_in || r?.timeIn);
				const hasTimeOut = Boolean(r?.time_out || r?.timeOut);
				const isAbsent = Number(r?.is_absent || 0) === 1;
				const isLeave = Number(r?.leave_approved || 0) === 1 || String(r?.status || '').toLowerCase() === 'leave';
				return !manualPending && hasTimeIn && !hasTimeOut && !isAbsent && !isLeave;
			};
			const openRow = rows.find(isOpenAttendanceRow) || null;
			const activeBreakRow = rows.find((r) => isOpenAttendanceRow(r) && r?.break_start && !r?.break_end) || null;
			const pendingRow = rows.find((r) => (
				String(r?.manual_request_status || '').toLowerCase() === 'pending'
			));
			const pending = !!pendingRow;
			setHasOpenShift(Boolean(openRow));
			setIsOnBreak(Boolean(activeBreakRow));
			setOpenShiftRecord(openRow);
			setHasPendingManualShift(pending);
			setPendingManualRequest(pending ? {
				status: 'pending',
				requested_date: pendingRow?.log_date || '',
				requested_time: pendingRow?.log_time || ''
			} : null);
		} catch (e) {
			console.error('Failed to fetch attendance', e);
			setMessage('Failed to load attendance');
		} finally { setLoading(false); }
	};

	useEffect(() => {
		const activeBreakStart = openShiftRecord?.break_start;
		if (!isOnBreak || !activeBreakStart) {
			setBreakCountdownMs(0);
			return undefined;
		}

		const breakStartedAt = buildAttendanceDateTime(openShiftRecord?.log_date || new Date(), activeBreakStart);
		if (!breakStartedAt) {
			setBreakCountdownMs(0);
			return undefined;
		}

		const breakEndsAt = new Date(breakStartedAt.getTime() + (60 * 60 * 1000));
		const updateCountdown = () => {
			setBreakCountdownMs(Math.max(0, breakEndsAt.getTime() - Date.now()));
		};

		updateCountdown();
		const timer = window.setInterval(updateCountdown, 1000);
		return () => window.clearInterval(timer);
	}, [buildAttendanceDateTime, isOnBreak, openShiftRecord]);

	const activeBreakStartAt = React.useMemo(() => {
		if (!isOnBreak || !openShiftRecord?.break_start) return null;
		return buildAttendanceDateTime(openShiftRecord?.log_date || new Date(), openShiftRecord.break_start);
	}, [buildAttendanceDateTime, isOnBreak, openShiftRecord]);

	const activeBreakEndAt = React.useMemo(() => {
		if (!activeBreakStartAt) return null;
		return new Date(activeBreakStartAt.getTime() + (60 * 60 * 1000));
	}, [activeBreakStartAt]);

	const breakStartLabel = activeBreakStartAt ? formatDateTimeToTime12h(activeBreakStartAt) : '-';
	const breakReturnLabel = activeBreakEndAt ? formatDateTimeToTime12h(activeBreakEndAt) : '-';
	const breakCountdownLabel = formatCountdownLabel(breakCountdownMs);

	const fetchManualFeedback = async () => {
		try {
			const res = await axios.get(`${API_BASE}/api/attendance/manual-requests/mine?limit=1`, { withCredentials: true });
			const rows = Array.isArray(res?.data?.rows) ? res.data.rows : [];
			if (!rows.length) {
				setLastManualFeedback(null);
				return;
			}
			const row = rows[0];
			const cleanedReason = String(row?.reason || '').trim();
			const normalizedReason = (cleanedReason && cleanedReason.toLowerCase() !== 'null' && cleanedReason.toLowerCase() !== 'hr: null')
				? cleanedReason
				: '';
			setLastManualFeedback({
				status: String(row?.status || '').trim().toLowerCase(),
				resolution: String(row?.resolution || '').trim().toLowerCase(),
				reason: normalizedReason,
				reviewed_at: row?.reviewed_at || null,
			});
		} catch (e) {
			// optional UI feedback only
		}
	};

	const fetchUnreadInboxCount = async () => {
		try {
			const res = await axios.get(`${API_BASE}/api/notifications`, { withCredentials: true });
			const rows = Array.isArray(res?.data) ? res.data : [];
			setUnreadInboxCount(rows.filter((n) => !n.is_read).length);
		} catch (e) {
			// non-blocking
		}
	};

	
	useEffect(() => {
		const section = new URLSearchParams(location.search || '').get('section');
		const allowedSections = new Set(['home', 'attendance-cam', 'attendance-record', 'dtr-upload']);
		const nextSection = allowedSections.has(section || activeSection) ? (section || activeSection) : 'home';
		if (nextSection !== activeSection) setActiveSection(nextSection);
		if (section && nextSection !== section) {
			try { navigate(`${basePath}?section=${nextSection}`, { replace: true }); } catch (e) {}
		}
	}, [location.search, activeSection, navigate, basePath]);

	useEffect(() => {
		const target = `${basePath}?section=${activeSection}`;
		const current = `${location.pathname}${location.search || ''}`;
		if (!location.search && location.pathname === basePath) {
			if (current !== target) {
				try { navigate(target, { replace: true }); } catch (e) {}
			}
		}
	}, [location.search, location.pathname, activeSection, navigate]);

	useEffect(() => {
		if (isAttendanceSectionActive && !attendanceOpen) setAttendanceOpen(true);
	}, [isAttendanceSectionActive, attendanceOpen]);

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => { fetchAttendance(); fetchManualFeedback(); fetchUnreadInboxCount(); fetchInventoryItems(); fetchInventoryRequests(); fetchCurrentDeployment(); return () => { stopCamera(); }; }, []);
	useEffect(() => {
		const t = setInterval(() => { fetchUnreadInboxCount(); fetchCurrentDeployment(); }, 30000);
		return () => clearInterval(t);
	}, []);

	const openInboxSection = () => {
		setActiveSection('inbox');
		try { navigate(`${basePath}?section=inbox`); } catch (e) {}
	};

	useEffect(() => {
		if (activeSection !== 'file-leave' || !user) return;
		fetchMyLeaveRequests();
	}, [activeSection, user]);
	useEffect(() => {
		if (activeSection !== 'dtr-upload' || !user) return;
		fetchDtrEvidence();
	}, [activeSection, user]);
	const submitManualRequestWithReason = async (reasonText) => {
		const cleanedReason = String(reasonText || '').trim();
		if (!cleanedReason) {
			setSnack({
				open: true,
				severity: 'warning',
				message: 'Reason is required for no-camera time in.'
			});
			return;
		}

		if (!manualEvidenceFile) {
			setSnack({
				open: true,
				severity: 'warning',
				message: 'Attach a proof photo before sending the no-camera time-in request.'
			});
			return;
		}

		setManualLoading(true);
		try {
			const nowLocal = getLocalSqlNow();
			const payload = new FormData();
			payload.append('reason', cleanedReason);
			payload.append('requested_date', nowLocal.date);
			payload.append('requested_time', nowLocal.time);
			if (manualEvidenceFile) {
				payload.append('evidence', manualEvidenceFile);
			}
			const res = await axios.post(
				`${API_BASE}/api/attendance/manual-requests`,
				payload,
				{ withCredentials: true }
			);
			const reqRow = res?.data?.request || null;
			if (reqRow) setPendingManualRequest(reqRow);
			if (res?.data?.attendance?.id) setHasOpenShift(true);
			setHasPendingManualShift(true);
			const reqDate = reqRow?.requested_date || '';
			const reqTime = reqRow?.requested_time || '';
			const when = [reqDate, reqTime].filter(Boolean).join(' ');
			setSnack({
				open: true,
				message: when ? `Your no-camera time-in request was sent at ${when} (Status: Pending HR approval).` : 'Your no-camera time-in request was sent (Status: Pending HR approval).',
				severity: 'success'
			});
			setManualReason('');
			setManualReasonDraft('');
			setManualEvidenceFile(null);
			setManualReasonDialogOpen(false);
			await fetchAttendance();
			await fetchManualFeedback();
		} catch (e) {
			const apiCode = String(e?.response?.data?.code || '').trim().toUpperCase();
			if (apiCode === 'OPEN_SHIFT_EXISTS' || apiCode === 'ATTENDANCE_ALREADY_EXISTS') {
				try { await fetchAttendance(); } catch (_) {}
				try { await fetchManualFeedback(); } catch (_) {}
			}
			showApiMessage(e, 'Failed to send request. Please try again.');
		} finally {
			setManualLoading(false);
		}
	};

	const submitManualRequest = async () => {
		if (!manualAttendanceAllowed) {
			setSnack({
				open: true,
				severity: 'info',
				message: cameraAvailability === 'checking'
					? 'Checking camera availability. Please wait a moment.'
					: 'Manual time-in is only available when no camera device is detected.'
			});
			return;
		}
		if (timeInLocked) {
			setSnack({
				open: true,
				severity: 'warning',
				message: hasPendingManualShift
					? 'You already have a pending no-camera request. Please wait for HR action.'
					: "You are already timed in. Please time out before sending another manual time-in request."
			});
			return;
		}
		setManualReasonDraft((manualReason || '').trim());
		setManualEvidenceFile(null);
		setManualReasonDialogOpen(true);
	};

	// Camera controls preserved
	const startCamera = async () => {
		if (cameraOn) return;
		try {
			// Try default facingMode first
			let stream;
			try {
				stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' } });
			} catch (e) {
				console.warn('getUserMedia facingMode failed, trying enumerateDevices fallback', e);
				// fallback: enumerate devices and pick first available video input
				const devices = await navigator.mediaDevices.enumerateDevices();
				const videoInput = devices.find(d => d.kind === 'videoinput');
				if (videoInput && videoInput.deviceId) {
					try {
						stream = await navigator.mediaDevices.getUserMedia({ video: { deviceId: { exact: videoInput.deviceId } } });
					} catch (e2) {
						console.warn('getUserMedia by deviceId failed', e2);
					}
				}
			}
			if (!stream) {
				alert('No camera found. Please connect a camera and grant permission.');
				setMessage('No camera detected');
				return;
			}
			streamRef.current = stream;
			if (videoRef.current) videoRef.current.srcObject = stream;
			setCameraOn(true);
		} catch (err) {
			console.error('Camera start failed', err);
			setMessage('Unable to access camera');
		}
	};
	const stopCamera = () => {
		try { if (streamRef.current) { streamRef.current.getTracks().forEach(t => t.stop()); streamRef.current = null; } } catch (e) {}
		setCameraOn(false);
	};

	const captureAndRecognize = async () => {
		if (faceServiceOffline) {
			setSnack({ open: true, message: 'Face recognition temporarily paused because the face service is offline.', severity: 'warning' });
			return;
		}
		if (!cameraOn || !videoRef.current) { setMessage('Camera is not started'); return; }
		setBusy(true);
		try {
			const video = videoRef.current;
			const canvas = canvasRef.current || document.createElement('canvas');
			canvas.width = video.videoWidth || 640;
			canvas.height = video.videoHeight || 480;
			const ctx = canvas.getContext('2d');
			ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
			// show capturing toast
			setSnack({ open: true, message: 'ðŸ“¸ Capturing face...', severity: 'info' });
			canvas.toBlob(async (blob) => {
				if (!blob) { setSnack({ open: true, message: 'Capture failed', severity: 'error' }); setBusy(false); return; }
				await sendRecognitionBlob(blob);
			}, 'image/png');
		} catch (err) {
			console.error('Capture error', err);
			setSnack({ open: true, message: 'Failed to capture image', severity: 'error' });
			setBusy(false);
		}
	};

		const sendRecognitionBlob = async (blob) => {
			if (faceServiceOffline) {
				setSnack({ open: true, message: 'Face recognition temporarily paused because the face service is offline.', severity: 'warning' });
				setBusy(false);
				return;
			}
		setSnack({ open: true, message: 'Scanning face...', severity: 'info' });
		try {
			const formData = new FormData();
			formData.append('image', blob, 'capture.png');
			const response = await axios.post(`${API_BASE}/api/recognize-face`, formData, { headers: { 'Content-Type': 'multipart/form-data' }, withCredentials: true });
			if (response && response.data) {
				const data = response.data || {};
				const recognitionCode = String(data.code || '').trim().toUpperCase();
				if (data.ok && data.code === 'RECOGNIZED') {
					const eid = data.employee_id || data.name || 'Unknown';
					const dist = typeof data.best_distance !== 'undefined' ? data.best_distance : null;
					setSnack({ open: true, message: `Recognized (Employee ID: ${eid}${dist !== null ? ` - ${dist}` : ''})`, severity: 'success' });
					const now = new Date();
					const isoDate = getCurrentDateKey();
					const isoTime = now.toTimeString().split(' ')[0];
					setRecognizedCandidate({ name: eid, date: isoDate, time: isoTime, raw: data });
					setRecognitionOpen(true);
				} else if (recognitionCode === 'NO_FACE' || recognitionCode === 'NO_FACE_DETECTED') {
					setSnack({ open: true, message: 'No face detected — move closer / better light', severity: 'warning' });
				} else if (recognitionCode === 'MULTIPLE_FACES') {
					setSnack({ open: true, message: 'Multiple faces detected. Make sure only one face is visible.', severity: 'warning' });
				} else if (recognitionCode === 'NO_ENCODINGS') {
					setSnack({ open: true, message: 'No registered face data was found for this account. Upload face photos first.', severity: 'warning' });
				} else if (recognitionCode === 'NO_MATCH' || recognitionCode === 'FACE_NOT_RECOGNIZED') {
					setSnack({ open: true, message: 'Face detected but not recognized. Please upload more photos or try again.', severity: 'warning' });
				} else if (recognitionCode === 'FACE_RECOGNITION_NOT_ALLOWED') {
					setSnack({ open: true, message: data.message || 'Face recognition is available only for custodian accounts.', severity: 'warning' });
				} else if (recognitionCode === 'EMPLOYEE_CONTEXT_MISSING') {
					setSnack({ open: true, message: data.message || 'Unable to resolve the logged-in employee for face recognition.', severity: 'warning' });
				} else {
					setSnack({ open: true, message: data.message || 'Recognition failed', severity: 'warning' });
				}
			} else {
				setSnack({ open: true, message: 'No response from recognition service', severity: 'error' });
			}
		} catch (err) {
			console.error('Recognition request failed', err);
			const data = err?.response?.data || {};
			const recognitionCode = String(data.code || '').trim().toUpperCase();
			if (err?.response?.status === 503 && err?.response?.data?.error === 'FACE_SERVICE_UNAVAILABLE') {
				triggerFaceServiceOffline();
				setSnack({ open: true, message: 'Face service is offline. Please ask the system administrator to start it.', severity: 'warning' });
			} else if (recognitionCode === 'UNAUTHORIZED') {
				setSnack({ open: true, message: data.message || 'Your login session was not found. Sign in again and retry face recognition.', severity: 'warning' });
			} else if (recognitionCode === 'FACE_RECOGNITION_NOT_ALLOWED') {
				setSnack({ open: true, message: data.message || 'Face recognition is available only for custodian accounts.', severity: 'warning' });
			} else if (recognitionCode === 'EMPLOYEE_CONTEXT_MISSING') {
				setSnack({ open: true, message: data.message || 'Unable to resolve the logged-in employee for face recognition.', severity: 'warning' });
			} else if (recognitionCode === 'NO_ENCODINGS') {
				setSnack({ open: true, message: data.message || 'No registered face data was found for this account. Upload face photos first.', severity: 'warning' });
			} else if (recognitionCode === 'NO_FACE_DETECTED' || recognitionCode === 'NO_FACE') {
				setSnack({ open: true, message: data.message || 'No face detected. Move closer and improve lighting.', severity: 'warning' });
			} else if (recognitionCode === 'MULTIPLE_FACES') {
				setSnack({ open: true, message: data.message || 'Multiple faces detected. Make sure only one face is visible.', severity: 'warning' });
			} else if (recognitionCode === 'NO_MATCH' || recognitionCode === 'FACE_NOT_RECOGNIZED') {
				setSnack({ open: true, message: data.message || 'Face detected but not recognized. Please try again.', severity: 'warning' });
			} else if (err && err.response && err.response.status === 500) {
				setSnack({ open: true, message: 'Server error from recognition service', severity: 'error' });
			} else {
				setSnack({ open: true, message: 'Recognition failed', severity: 'error' });
			}
		} finally { setBusy(false); }
	};

	const confirmRecognized = async () => {
		if (!recognizedCandidate) return;
		if (timeInLocked) {
			setSnack({
				open: true,
				severity: 'warning',
				message: hasPendingManualShift
					? 'You have a pending no-camera request. Wait for HR action first.'
					: "You already timed in and haven't timed out yet."
			});
			return;
		}
		setBusy(true);
		try {
			const res = await axios.post(
				`${API_BASE}/api/attendance/mark-time-in`,
				{ log_date: recognizedCandidate.date, log_time: recognizedCandidate.time },
				{ withCredentials: true }
			);

			if (res && res.data) {
				// Use helper; only continue if it returns true
				const ok = handleTimeInResponse(res.data);
				if (ok) {
					setMessage(`Time-in recorded: ${recognizedCandidate.date} ${recognizedCandidate.time}`);
					setRecognitionOpen(false);
					setRecognizedCandidate(null);
					await fetchAttendance();
					await fetchManualFeedback();
					await fetchPayroll();
				}
			}
		} catch (err) {
			console.error('Failed to mark time-in', err);
			showApiMessage(err, 'Failed to record attendance.');
		} finally {
			setBusy(false);
		}
	};


	const handleTimeInResponse = (payload) => {
		if (!payload) return true;

		// If backend signals that an open shift already exists for today
		if (payload.code === 'OPEN_SHIFT_EXISTS' || payload.code === 'DAY_ALREADY_TIMED_IN') {
			setHasOpenShift(true);
			setSnack({
				open: true,
				severity: 'warning',
				message: payload.message || "You already timed in and haven't timed out yet."
			});
			return false;
		}

		// Show info if a previous shift was auto time-out (e.g., cross-midnight)
		if (payload.autoTimedOut) {
			setSnack({
				open: true,
				severity: 'info',
				message: 'Previous shift was auto time-out after 8 hours or at midnight.'
			});
		}

		// If we get a payroll preview, open it
		if (payload.payrollPreview) {
			setPayrollPreview(payload.payrollPreview);
			setPayrollPreviewOpen(true);
		}

		// A successful time-in means there is now an open shift
		setHasOpenShift(true);
		setIsOnBreak(false);
		setOpenShiftRecord(null);
		setHasPendingManualShift(false);
		setPendingManualRequest(null);
		return true;
	};

	const handleCustodianTimeOut = () => {
		setTimeOutDialogOpen(true);
	};

	const confirmCustodianTimeOut = async () => {
		if (!user) return;
		if (!hasOpenShift) {
			setSnack({
				open: true,
				severity: 'warning',
				message: hasPendingManualShift
					? 'You have a pending no-camera request. Wait for HR approval before time out.'
					: 'You have not timed in today. Time out is disabled.'
			});
			return;
		}
		if (isOnBreak) {
			setSnack({
				open: true,
				severity: 'warning',
				message: 'End break before timing out.'
			});
			return;
		}
		setBusy(true);
		try {
			console.info('[attendance][frontend][custodian-timeout] request', {});
			const res = await axios.post(`${API_BASE}/api/attendance/time-out`, {}, { withCredentials: true });
			const payload = res?.data || null;
			console.info('[attendance][frontend][custodian-timeout] response', payload);

			if (payload && payload.ok) {
				// Let the same helper handle payroll preview, autoTimedOut, etc.
				handleTimeInResponse(payload);

				setSnack({
					open: true,
					severity: 'success',
					message: payload.message || 'Time-out recorded.'
				});

				// Closing the shift
				setHasOpenShift(false);
				setIsOnBreak(false);
				setOpenShiftRecord(null);
				setHasPendingManualShift(false);
				setPendingManualRequest(null);

				await fetchAttendance();
				await fetchManualFeedback();
				await fetchPayroll();
				console.info('[attendance][frontend][custodian-timeout] refreshed');
			} else {
				showApiMessage(payload || null, 'Failed to record time-out.');
			}
		} catch (err) {
			console.error('Custodian time-out error', err);
			showApiMessage(err, 'Failed to record time-out.');
		} finally {
			setBusy(false);
			setTimeOutDialogOpen(false);
		}
	};

	const startCustodianBreak = async () => {
		if (!hasOpenShift) {
			setSnack({ open: true, severity: 'warning', message: 'Time in first before starting your break.' });
			return;
		}
		setBusy(true);
		try {
			const res = await axios.post(`${API_BASE}/api/attendance/break/start`, {}, { withCredentials: true });
			setIsOnBreak(true);
			setSnack({ open: true, severity: 'success', message: res?.data?.message || 'Break started.' });
			await fetchAttendance();
		} catch (err) {
			showApiMessage(err, 'Failed to start break.');
		} finally {
			setBusy(false);
		}
	};

	const endCustodianBreak = async () => {
		if (!hasOpenShift) {
			setSnack({ open: true, severity: 'warning', message: 'No open shift found.' });
			return;
		}
		setBusy(true);
		try {
			const res = await axios.post(`${API_BASE}/api/attendance/break/end`, {}, { withCredentials: true });
			setIsOnBreak(false);
			setOpenShiftRecord((prev) => prev ? { ...prev, break_end: res?.data?.break_end || prev.break_end || getLocalSqlNow().time } : prev);
			setSnack({ open: true, severity: 'success', message: res?.data?.message || 'Break ended.' });
			await fetchAttendance();
		} catch (err) {
			showApiMessage(err, 'Failed to end break.');
		} finally {
			setBusy(false);
		}
	};

	// Payroll helpers
	const fetchPayroll = async (month = selectedMonth, year = selectedYear) => {
		setPayrollLoading(true);
		setPayrollError('');
		try {
			const row = await fetchPayslipRow(API_BASE, { month, year, cutoffId: selectedPayslipCutoffId });
			if (row) {
				setPayslip(buildPayslipFromHistoryRow(row));
				setPayrollError('');
			} else {
				setPayslip(null);
				setPayrollError('');
			}
		} catch (err) {
			if (err?.response?.status === 404) {
				setPayrollError('');
			} else {
				console.error('Custodian payslip fetch error', err);
				setPayrollError('Failed to load payslip.');
			}
			setPayslip(null);
		} finally { setPayrollLoading(false); }
	};

	const fetchPersonalPayrollCutoffs = async () => {
		try {
			const res = await axios.get(`${API_BASE}/api/payroll/cutoffs/me`, { withCredentials: true });
			const rows = Array.isArray(res.data) ? res.data : [];
			setPersonalPayrollCutoffs(rows);
			setSelectedPayslipCutoffId((prev) => prev || (rows[0]?.id ? String(rows[0].id) : ''));
		} catch (error) {
			console.error('Failed to load personal payroll cutoffs:', error);
			setPersonalPayrollCutoffs([]);
		}
	};

	const handlePayslipPrev = () => {
		if (selectedYear === minYear && selectedMonth <= minMonth) return;
		setSelectedMonth((prevMonth) => {
			if (prevMonth === 1) {
				setSelectedYear((y) => y - 1);
				return 12;
			}
			return prevMonth - 1;
		});
	};

	const handlePayslipNext = () => {
		if (selectedYear > currentYear || (selectedYear === currentYear && selectedMonth >= currentMonth)) return;
		setSelectedMonth((prevMonth) => {
			if (prevMonth === 12) {
				setSelectedYear((y) => y + 1);
				return 1;
			}
			return prevMonth + 1;
		});
	};

	const currentPayslip = payslip;
	const printPayslipOnly = () => {
		const node = document.querySelector('.payslip-print');
		if (!node) return window.print();
		const popup = window.open('', '_blank', 'width=900,height=1200');
		if (!popup) return window.print();
		popup.document.write(`
			<html>
				<head>
					<title>Payslip</title>
					<meta charset="utf-8" />
					<style>
						body { font-family: Arial, sans-serif; margin: 20px; color: #111; }
						* { box-sizing: border-box; }
						table { width: 100% !important; border-collapse: collapse; table-layout: fixed; }
						th, td { border: 1px solid #d0d0d0; padding: 6px; vertical-align: top; word-break: break-word; }
					</style>
				</head>
				<body>${node.outerHTML}</body>
			</html>
		`);
		popup.document.close();
		popup.focus();
		popup.print();
		popup.close();
	};

	useEffect(() => {
		if (activeSection === 'payroll') {
			fetchPersonalPayrollCutoffs();
			fetchPayroll(selectedMonth, selectedYear);
		}
	}, [activeSection, selectedMonth, selectedYear, selectedPayslipCutoffId]);

	// Inventory items names
	const fetchInventoryItems = async () => {
		try {
			let items = [];
			try {
				const res = await axios.get(`${API_BASE}/api/inventory/items-with-stock`, { withCredentials: true });
				items = Array.isArray(res.data) ? res.data : [];
			} catch (inner) {
				const res2 = await axios.get(`${API_BASE}/api/inventory-items`, { withCredentials: true });
				items = Array.isArray(res2.data) ? res2.data : [];
			}
			if (!items || items.length === 0) {
				items = DEFAULT_INVENTORY_ITEMS.map((name) => ({ id: null, item_name: name, quantity: 0 }));
			}
			setInventoryItems(items);
			if (!reqItemId && items.length > 0) setReqItemId(String(items[0].id || items[0].item_name));
		} catch (e) { console.error('Failed to load inventory items', e); }
	};

	const submitInventoryRequest = async () => {
		try {
			const selected = inventoryItems.find((it) => String(it.id || it.item_name) === String(reqItemId));
			if (!selected) { setSnack({ open: true, message: 'Select an item', severity: 'warning' }); return; }
			const qtyNum = Math.max(1, parseInt(String(reqQty || '').trim(), 10) || 1);
			const payload = { quantity: qtyNum, message: reqMessage || null };
			if (selected.id) payload.item_id = selected.id;
			else payload.item_name = selected.item_name;
			await axios.post(`${API_BASE}/api/inventory/requests`, payload, { withCredentials: true });
			setReqMessage(''); setReqQty('1');
			setSnack({ open: true, message: 'Request submitted, waiting for approval.', severity: 'success' });
			// Refresh inventory items/requests where applicable
			try { await fetchInventoryItems(); } catch (e) {}
			try { await fetchInventoryRequests(); } catch (e) {}
		} catch (e) {
			console.error('Request failed', e);
			const msg = e?.response?.data?.error || 'Failed to submit request';
			setSnack({ open: true, message: msg, severity: 'error' });
		}
	};

	const fetchDtrEvidence = async () => {
		setDtrEvidenceLoading(true);
		try {
			const res = await axios.get(`${API_BASE}/api/attendance/dtr-evidence/mine`, {
				withCredentials: true,
				headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
			});
			setDtrEvidenceRows(Array.isArray(res?.data?.rows) ? res.data.rows : []);
		} catch (e) {
			console.error('Failed to load DTR uploads', e);
			setDtrEvidenceRows([]);
		} finally {
			setDtrEvidenceLoading(false);
		}
	};

	const submitDtrEvidence = async () => {
		if (!dtrEvidenceFile) {
			setSnack({ open: true, message: 'Attach a DTR photo before submitting.', severity: 'warning' });
			return;
		}
		setDtrEvidenceLoading(true);
		try {
			const form = new FormData();
			form.append('evidence', dtrEvidenceFile);
			if (dtrEvidenceNotes.trim()) form.append('notes', dtrEvidenceNotes.trim());
			await axios.post(`${API_BASE}/api/attendance/dtr-evidence`, form, {
				withCredentials: true,
				headers: { 'Content-Type': 'multipart/form-data' },
			});
			setDtrEvidenceFile(null);
			setDtrEvidenceNotes('');
			setSnack({ open: true, message: 'DTR photo uploaded for HR review.', severity: 'success' });
			await fetchDtrEvidence();
		} catch (e) {
			console.error('Failed to upload DTR photo', e);
			setSnack({ open: true, message: e?.response?.data?.error || 'Failed to upload DTR photo.', severity: 'error' });
		} finally {
			setDtrEvidenceLoading(false);
		}
	};

	const loadMyRequests = async () => {
		setLoadingRequests(true);
		try {
			const res = await axios.get(`${API_BASE}/api/inventory/requests/me`, { withCredentials: true });
			const rows = Array.isArray(res?.data?.requests)
				? res.data.requests
				: (Array.isArray(res?.data) ? res.data : []);
			setMyRequests(rows);
		} catch (e) {
			console.error('Failed to load my inventory requests', e);
		} finally {
			setLoadingRequests(false);
		}
	};

	const fetchInventoryRequests = () => loadMyRequests();

	const openInventoryForItem = (item = null) => {
		if (item) setReqItemId(String(item.id || item.item_name || item.label || ''));
		setActiveSection('inventory');
		try { navigate(`${basePath}?section=inventory`); } catch (e) {}
	};

	const fetchCurrentDeployment = async () => {
		setDeploymentLoading(true);
		try {
			const res = await axios.get(`${API_BASE}/api/deployments/me`, { withCredentials: true });
			const deployment = res?.data?.deployment || null;
			const endDateKey = deployment?.end_date ? toDateKey(deployment.end_date) : '';
			const todayKey = getCurrentDateKey();
			const deploymentStatus = String(deployment?.deployment_status || '').toLowerCase();
			if (!deployment || deploymentStatus === 'ended' || (endDateKey && todayKey && endDateKey < todayKey)) {
				setCurrentDeployment(null);
			} else {
				setCurrentDeployment(deployment);
			}
		} catch (e) {
			console.error('Failed to load current deployment', e);
			setCurrentDeployment(null);
		} finally {
			setDeploymentLoading(false);
		}
	};

	const handleCancelRequest = async (requestId) => {
		try {
			setLoading(true);
			await axios.post(`${API_BASE}/api/inventory/requests/${requestId}/cancel`, {}, { withCredentials: true });
			await fetchInventoryRequests();
			setSnack({ open: true, message: 'Request cancelled.', severity: 'success' });
		} catch (e) {
			console.error('Failed to cancel inventory request', e);
			const msg =
				e?.response?.data?.error ||
				(e?.response?.status === 403
					? 'You can only cancel your own pending requests.'
					: 'Failed to cancel inventory request.');
			setSnack({ open: true, message: msg, severity: 'error' });
		} finally {
			setLoading(false);
		}
	};

	const fetchMyLeaveRequests = async () => {
		setMyLeaveLoading(true);
		setMyLeaveError('');
		try {
			const res = await axios.get(`${API_BASE}/api/leave-requests/me`, {
				withCredentials: true,
			});
			const rows = Array.isArray(res?.data?.rows)
				? res.data.rows
				: (Array.isArray(res?.data) ? res.data : []);
			setMyLeaveRequests(rows || []);
		} catch (e) {
			console.error('Custodian fetchMyLeaveRequests failed', e);
			setMyLeaveError('Failed to load your leave requests.');
			setMyLeaveRequests([]);
		} finally {
			setMyLeaveLoading(false);
		}
	};
	// Layout helpers
	const drawerWidth = 260;

	return (
		<React.Fragment>
			<Box sx={{
			display: 'flex',
			minHeight: '100vh',
			bgcolor: '#f0f4ff',
			'& .MuiButton-contained:not(.MuiButton-containedError)': {
				bgcolor: '#2a3f9f',
				'&:hover': { bgcolor: '#22367f' }
			}
		}} >
			<style>{`@media print { .no-print { display: none !important; } .print-area { padding: 0 !important; margin: 0 !important; } body { background: #fff; } }`}</style>
						{/* Sidebar */}
			<Drawer className="no-print" variant="permanent" open sx={{ display: { xs: 'none', md: 'block' }, '& .MuiDrawer-paper': { width: drawerWidth, bgcolor: '#3b63b8', color: 'white', boxSizing: 'border-box' } }}>
				<Box sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', overflowY: 'auto' }}>
					<Box>
						<Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
							<Box sx={{ width: 44, height: 44, bgcolor: 'white', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
								<Typography sx={{ color: '#2f74d0', fontWeight: 'bold' }}>EZ</Typography>
							</Box>
							<Box>
								<Typography sx={{ fontWeight: 700 }}>EZRA GENERAL</Typography>
								<Typography variant="caption">CUSTODIAN</Typography>
							</Box>
			
						</Box>
		<List>
							<SidebarNavItem label="Home" icon={<HomeIcon />} to={`${basePath}?section=home`} exact onClick={() => setActiveSection('home')} />
										<ListItem disablePadding>
											<ListItemButton selected={isAttendanceSectionActive} onClick={() => setAttendanceOpen(o => !o)}>
											<ListItemIcon sx={{ color: 'white' }}><HistoryIcon /></ListItemIcon>
											<ListItemText primary="Attendance" />
											{attendanceOpen ? <ExpandLess /> : <ExpandMore />}
											</ListItemButton>
										</ListItem>
										<Collapse in={attendanceOpen} timeout="auto" unmountOnExit>
											<List component="div" disablePadding>
												<SidebarNavItem label="Attendance Cam" to={`${basePath}?section=attendance-cam`} exact onClick={() => setActiveSection('attendance-cam')} sx={{ pl: 4 }} />
												<SidebarNavItem label="Attendance Record" to={`${basePath}?section=attendance-record`} exact onClick={() => setActiveSection('attendance-record')} sx={{ pl: 4 }} />
											</List>
										</Collapse>
										<SidebarNavItem label="Attendance Evidence Upload" icon={<AssignmentIcon />} to={`${basePath}?section=dtr-upload`} exact onClick={() => setActiveSection('dtr-upload')} />
								</List>
					</Box>

					<Box>
						<Divider sx={{ bgcolor: '#ffffff33', my: 1 }} />
						<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, cursor: 'pointer' }} onClick={() => setProfileOpen(true)}>
							<Avatar src={profilePhotoId ? `${API_BASE}/api/photos_blob/image/${profilePhotoId}` : undefined} sx={{ bgcolor: '#e9eef9', color: '#2f74d0' }}>{(user && user.firstname ? user.firstname[0] : 'C')}</Avatar>
							<Box>
								<Typography variant="body2" sx={{ fontWeight: 700 }}>{user ? (fullDisplayName || 'Custodian') : 'Custodian'}</Typography>
								<Typography variant="caption">{user && (user.employeeid || user.username) ? String(user.employeeid || user.username).padStart(8,'0') : ''}</Typography>
							</Box>
						</Box>
						<Button variant="contained" color="error" startIcon={<LogoutIcon />} onClick={() => { try { onLogout && onLogout(); } catch (e) {} }} fullWidth>Logout</Button>
					</Box>
				</Box>
			</Drawer>
			<Drawer
				className="no-print"
				variant="temporary"
				open={mobileOpen}
				onClose={() => setMobileOpen(false)}
				ModalProps={{ keepMounted: true }}
				sx={{ display: { xs: 'block', md: 'none' }, '& .MuiDrawer-paper': { width: drawerWidth, bgcolor: '#3b63b8', color: 'white', boxSizing: 'border-box' } }}
			>
				<Box sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', overflowY: 'auto' }}>
					<Box>
						<Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
							<Box sx={{ width: 44, height: 44, bgcolor: 'white', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
								<Typography sx={{ color: '#2f74d0', fontWeight: 'bold' }}>EZ</Typography>
							</Box>
							<Box>
								<Typography sx={{ fontWeight: 700 }}>EZRA GENERAL</Typography>
								<Typography variant="caption">CUSTODIAN</Typography>
							</Box>
						</Box>
						<List>
							<SidebarNavItem label="Home" icon={<HomeIcon />} to={`${basePath}?section=home`} exact onClick={() => { setActiveSection('home'); setMobileOpen(false); }} />
							<ListItem disablePadding>
								<ListItemButton selected={isAttendanceSectionActive} onClick={() => setAttendanceOpen(o => !o)}>
									<ListItemIcon sx={{ color: 'white' }}><HistoryIcon /></ListItemIcon>
									<ListItemText primary="Attendance" />
									{attendanceOpen ? <ExpandLess /> : <ExpandMore />}
								</ListItemButton>
							</ListItem>
							<Collapse in={attendanceOpen} timeout="auto" unmountOnExit>
								<List component="div" disablePadding>
									<SidebarNavItem label="Attendance Cam" to={`${basePath}?section=attendance-cam`} exact onClick={() => { setActiveSection('attendance-cam'); setMobileOpen(false); }} sx={{ pl: 4 }} />
									<SidebarNavItem label="Attendance Record" to={`${basePath}?section=attendance-record`} exact onClick={() => { setActiveSection('attendance-record'); setMobileOpen(false); }} sx={{ pl: 4 }} />
								</List>
							</Collapse>
							<SidebarNavItem label="Attendance Evidence Upload" icon={<AssignmentIcon />} to={`${basePath}?section=dtr-upload`} exact onClick={() => { setActiveSection('dtr-upload'); setMobileOpen(false); }} />
						</List>
					</Box>
					<Box>
						<Divider sx={{ bgcolor: '#ffffff33', my: 1 }} />
						<Button variant="contained" color="error" startIcon={<LogoutIcon />} onClick={() => { try { onLogout && onLogout(); } catch (e) {} }} fullWidth>Logout</Button>
					</Box>
				</Box>
			</Drawer>

			{/* Main content area */}
			<Box sx={{ flex: 1, p: { xs: 1, sm: 2, md: 3 }, overflow: 'auto', ml: { xs: 0, md: `${drawerWidth}px` } }}>
				<AppBar className="no-print" position="static" color="transparent" elevation={0} sx={{ mb: 2 }}>
					<Toolbar sx={{ bgcolor: 'white', borderRadius: 1, boxShadow: 1, border: '1px solid #e2e8f0', flexWrap: { xs: 'wrap', md: 'nowrap' }, rowGap: { xs: 1, md: 0 }, px: { xs: 1, sm: 2 }, py: { xs: 0.75, sm: 1 } }}>
						<IconButton sx={{ display: { xs: 'inline-flex', md: 'none' }, mr: 1 }} onClick={() => setMobileOpen(true)}>
							<MenuIcon />
						</IconButton>
						<Typography variant="h6" sx={{ flex: 1, fontWeight: 700, minWidth: 0, fontSize: { xs: '1rem', sm: '1.25rem' } }}>Custodian Dashboard</Typography>
						<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'flex-end', sm: 'initial' }, gap: { xs: 1, sm: 2 }, maxWidth: { xs: '100%', sm: 'none' }, width: { xs: '100%', sm: 'auto' }, flexWrap: 'wrap' }}>
							<LiveDateTimeWidget />
							<Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 }, cursor: 'pointer' }} onClick={() => setProfileOpen(true)}>
								<Typography variant="body2" sx={{ display: { xs: 'none', sm: 'block' } }}>{fullDisplayName || user?.username}</Typography>
								<Avatar src={profilePhotoId ? `${API_BASE}/api/photos_blob/image/${profilePhotoId}` : undefined} sx={{ bgcolor: '#e9eef9', color: '#2f74d0' }}>{(user && user.firstname ? user.firstname[0] : 'C')}</Avatar>
							</Box>
						</Box>
					</Toolbar>
				</AppBar>

				{/* Sections */}
				{activeSection === 'home' && (
					<Box>
						<Paper sx={{ p: { xs: 1.75, sm: 3 }, mb: 2 }}>
							<Typography variant="h5" sx={{ fontWeight: 700 }}>Welcome, {fullDisplayName || user?.username}</Typography>
							<Box sx={{ display: 'flex', gap: 1.5, mt: 2, flexWrap: 'wrap' }}>
								<Button
									variant="outlined"
									color={isOnBreak ? 'info' : 'secondary'}
									onClick={isOnBreak ? endCustodianBreak : startCustodianBreak}
									disabled={busy || !hasOpenShift}
									sx={{ minWidth: 140 }}
								>
									{busy ? <CircularProgress size={18} /> : (isOnBreak ? 'End Break' : 'Start Break')}
								</Button>
								<Button
									variant="outlined"
									color="error"
									onClick={handleCustodianTimeOut}
									disabled={busy || !hasOpenShift || isOnBreak}
									sx={{ minWidth: 120 }}
								>
									{busy ? <CircularProgress size={18} /> : 'Time Out'}
								</Button>
							</Box>
						</Paper>
						<Paper sx={{ p: { xs: 1.75, sm: 3 }, mb: 2 }}>
							<Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>Current Assignment</Typography>
							{deploymentLoading ? (
								<Typography variant="body2" color="text.secondary">Loading branch assignment...</Typography>
							) : !currentDeployment ? (
								<Alert severity="info">No active branch/site assignment yet. Ask HR to assign your deployment.</Alert>
							) : (
								<Box sx={{ display: 'grid', gap: 0.5 }}>
									{String(currentDeployment.deployment_status || '').toLowerCase() === 'upcoming' && (
										<Alert severity="info" sx={{ mb: 1 }}>
											Upcoming assignment starts on {formatDateOnly(currentDeployment.start_date)}.
										</Alert>
									)}
									<Typography variant="body2"><strong>Branch:</strong> {currentDeployment.branch_name || '—'}</Typography>
									<Typography variant="body2"><strong>Code:</strong> {currentDeployment.branch_code || '—'}</Typography>
									<Typography variant="body2"><strong>Location:</strong> {[currentDeployment.branch_address, currentDeployment.branch_city, currentDeployment.branch_province].filter(Boolean).join(', ') || '—'}</Typography>
									<Typography variant="body2"><strong>Shift:</strong> {currentDeployment.shift_start || '—'} {currentDeployment.shift_end ? `to ${currentDeployment.shift_end}` : ''}</Typography>
									<Typography variant="body2"><strong>Start Date:</strong> {formatDateOnly(currentDeployment.start_date)}</Typography>
									<Typography variant="body2"><strong>End Date:</strong> {currentDeployment.end_date ? formatDateOnly(currentDeployment.end_date) : '—'}</Typography>
								</Box>
							)}
						</Paper>
					<Paper sx={{ p: { xs: 1.75, sm: 3 } }}>
						<Typography variant="h6" gutterBottom>Personal Calendar</Typography>
						<PersonalCalendar employeeId={user?.employeeid || user?.employee_no} />
					</Paper>

					</Box>
				)}

				{activeSection === 'attendance-cam' && (
						<Paper sx={{ p: { xs: 1.75, sm: 3 } }}>
							<Typography variant="h5" sx={{ mb: 2 }}>Attendance Cam</Typography>

					{/* Show banner when there is an open shift */}
					{(hasOpenShift || hasPendingManualShift) && (
						<Box sx={{ mb: 2 }}>
							<Alert severity="info">
								{hasPendingManualShift
									? 'You have a pending no-camera time-in request. Wait for HR action before another time-in.'
									: <>You are currently <strong>timed in</strong>.</>}
							</Alert>
						</Box>
					)}
							<Box sx={{ mb: 2 }}>
								{message && <Typography variant="body2" sx={{ mb: 1 }}>{message}</Typography>}
								{faceServiceOffline && (
									<Typography variant="body2" sx={{ mb: 1, color: '#b45309' }}>
										Face recognition temporarily paused because the face service is offline.
									</Typography>
								)}
								{(() => {
									const targetCode = (() => {
										const raw = (user && (user.employeeid || user.username)) ? String(user.employeeid || user.username) : '';
										return raw ? raw.padStart(8, '0') : '';
									})();
									return <WebcamCapture targetEmployeeCode={targetCode} targetUserId={user?.id ? String(user.id) : ''} hasOpenShift={hasOpenShift} onCameraAvailabilityChange={setCameraAvailability} onManualFallbackEligibilityChange={setManualFallbackState} onTimeInSaved={(payload) => { const ok = handleTimeInResponse(payload); if (ok) { fetchAttendance(); fetchPayroll(); } }} onTimeOutSaved={async () => { setHasOpenShift(false); setHasPendingManualShift(false); setPendingManualRequest(null); await fetchAttendance(); await fetchManualFeedback(); await fetchPayroll(); }} disabled={hasPendingManualShift} />;
								})()}
							</Box>
							<Box sx={{ display: 'flex', gap: 1.5, alignItems: 'stretch', flexWrap: 'wrap', flexDirection: { xs: 'column', sm: 'row' } }}>
								<Button fullWidth={true} variant="contained" onClick={submitManualRequest} disabled={busy || manualLoading || timeInLocked || !manualAttendanceAllowed} sx={{ maxWidth: { xs: '100%', sm: 260 } }}>{manualLoading ? <CircularProgress size={18} /> : 'Request Manual Time In'}</Button>
							</Box>
							<Typography variant="body2" sx={{ mt: 1, color: manualAttendanceAllowed ? '#b45309' : 'text.secondary' }}>
								{cameraAvailability === 'checking'
									? 'Checking whether this device has a camera before enabling the manual fallback.'
									: manualFallbackState.eligible
									? `${getManualFallbackReasonLabel(manualFallbackState.reason)} happened ${manualFallbackState.failedAttempts} times. Manual time-in is now available for HR review.`
									: manualAttendanceAllowed
									? 'No camera device was detected. You may submit a manual time-in request for HR review.'
									: 'Manual time-in is an HR-reviewed fallback and is only available when no camera device is detected.'}
							</Typography>
							{pendingManualRequest && String(pendingManualRequest.status || '').toLowerCase() === 'pending' && (
								<Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>Manual time-in request pending HR approval.</Typography>
							)}
						</Paper>
				)}

				{activeSection === 'attendance-record' && (
					<Paper sx={{ p: { xs: 1.75, sm: 3 } }}>
						<Typography variant="h5" sx={{ mb: 2 }}>Attendance Records</Typography>
						{loading ? (
							<Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}><CircularProgress /></Box>
						) : (
							<TableContainer sx={{ overflowX: 'auto' }}>
								<Table size="small" sx={{ minWidth: { xs: 560, sm: 560 } }}>
									<TableHead>
										<TableRow>
											<TableCell>Date</TableCell>
											<TableCell>Time In</TableCell>
											<TableCell>Time Out</TableCell>
											<TableCell>Method</TableCell>
											<TableCell>Late</TableCell>
											<TableCell>Status</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{attendance.map((r, idx) => (
											<TableRow key={idx}>
												<TableCell>{formatDateOnly(r.log_date)}</TableCell>
												<TableCell>{r.log_time ? formatTime12h(r.log_time) : '-'}</TableCell>
												<TableCell>{r.time_out ? formatTime12h(r.time_out) : '-'}</TableCell>
												<TableCell>{getAttendanceMethod(r)}</TableCell>
												<TableCell>{r.late ? 'Yes' : (r.late_minutes ? `${r.late_minutes}m` : 'No')}</TableCell>
												<TableCell>{getStatusChip(getAttendanceStatusLabel(r))}</TableCell>
											</TableRow>
										))}
									</TableBody>
								</Table>
							</TableContainer>
						)}
					</Paper>
				)}

				{activeSection === 'payroll' && (
			<Paper className="print-area" sx={{ p: { xs: 1.75, sm: 3 } }}>
				<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: { xs: 'stretch', sm: 'center' }, flexDirection: { xs: 'column', sm: 'row' }, gap: 1.5, mb: 2 }}>
					<Typography variant="h5">Payslip</Typography>
					<Button className="no-print" variant="outlined" onClick={printPayslipOnly} sx={{ alignSelf: { xs: 'flex-start', sm: 'auto' } }}>
						PRINT
					</Button>
				</Box>

				{payrollLoading ? (
					<Typography>Loading payslip...</Typography>
				) : (
					<React.Fragment>
						{payrollError && (
							<Typography color="error">{payrollError}</Typography>
						)}
						<Box className="no-print" sx={{ display: 'flex', alignItems: { xs: 'stretch', sm: 'center' }, justifyContent: personalPayrollCutoffs.length > 0 ? 'flex-start' : 'space-between', gap: 1, flexWrap: 'wrap', mb: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
							{personalPayrollCutoffs.length > 0 ? (
								<FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 380 } }}>
									<Select
										value={selectedPayslipCutoffId}
										onChange={(e) => setSelectedPayslipCutoffId(String(e.target.value || ''))}
										displayEmpty
									>
										{personalPayrollCutoffs.map((cutoff) => (
											<MenuItem key={cutoff.id} value={String(cutoff.id)}>
												{`${formatDateOnly(cutoff.period_start)} - ${formatDateOnly(cutoff.period_end)} | Pay ${formatDateOnly(cutoff.pay_date)} | ${cutoff.status}`}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							) : (
								<React.Fragment>
									<IconButton onClick={handlePayslipPrev} size="small" sx={{ alignSelf: { xs: 'flex-start', sm: 'auto' } }}>
										<ChevronLeftIcon />
									</IconButton>
									<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', flex: 1, justifyContent: { xs: 'stretch', sm: 'center' }, width: { xs: '100%', sm: 'auto' } }}>
								<FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 140 }, flex: { xs: '1 1 100%', sm: '0 0 auto' } }}>
									<Select
										value={selectedMonth}
										onChange={(e) => setSelectedMonth(Number(e.target.value))}
										displayEmpty
									>
										{(() => {
											const bounds = getMonthBoundsForYear(selectedYear);
											const months = [];
											for (let m = bounds.start; m <= bounds.end; m += 1) months.push(m);
											return months;
										})().map((m) => (
											<MenuItem key={m} value={m}>
												{new Date(2000, m - 1, 1).toLocaleString('en-US', { month: 'long' })}
											</MenuItem>
										))}
									</Select>
								</FormControl>
								<FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 100 }, flex: { xs: '1 1 100%', sm: '0 0 auto' } }}>
									<Select
										value={selectedYear}
										onChange={(e) => {
											const y = Number(e.target.value);
											setSelectedYear(y);
											const bounds = getMonthBoundsForYear(y);
											if (selectedMonth < bounds.start) setSelectedMonth(bounds.start);
											if (selectedMonth > bounds.end) setSelectedMonth(bounds.end);
										}}
									>
										{availableYears.map((y) => <MenuItem key={y} value={y}>{y}</MenuItem>)}
									</Select>
								</FormControl>
									</Box>
									<IconButton
										onClick={handlePayslipNext}
										size="small"
										disabled={selectedYear === currentYear && selectedMonth === currentMonth}
										sx={{ alignSelf: { xs: 'flex-end', sm: 'auto' } }}
									>
										<ChevronRightIcon />
									</IconButton>
								</React.Fragment>
							)}
						</Box>

						{!payrollError && !currentPayslip && (
							<Typography color="text.secondary">
								No payslip found for this period.
							</Typography>
						)}

						{!payrollError && currentPayslip && (
							<PayslipCard payslip={currentPayslip} />
						)}
					</React.Fragment>
				)}
			</Paper>
		)}
{activeSection === 'inventory' && (
					<Paper sx={{ p: { xs: 1.75, sm: 3 } }}>
						<Typography variant="h5" sx={{ mb: 2 }}>Inventory Request</Typography>
						{!currentDeployment?.branch_name && (
							<Alert severity="warning" sx={{ mb: 2 }}>
								No active branch assignment. Your request can still be sent but branch tag may be empty.
							</Alert>
						)}
						<Box sx={{ display: 'flex', gap: 2, alignItems: 'stretch', mb: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
							<FormControl sx={{ minWidth: { xs: '100%', sm: 240 }, flex: 1 }}>
								<InputLabel>Item</InputLabel>
								<Select value={reqItemId} label="Item" onChange={(e) => setReqItemId(e.target.value)}>
					     {inventoryItems.map((it, idx) => (
						<MenuItem key={it.id || it.item_name || idx} value={String(it.id || it.item_name)}>
							{it.item_name}{typeof it.quantity !== 'undefined' ? ` (Available: ${it.quantity})` : ''}
						</MenuItem>
					     ))}
					</Select>
							</FormControl>
							<TextField
								label="Quantity"
								type="number"
								value={reqQty}
								onChange={(e) => setReqQty(e.target.value)}
								sx={{ width: { xs: '100%', sm: 120 } }}
								inputProps={{ min: 1 }}
							/>
						</Box>
						<TextField label="Message (optional)" fullWidth value={reqMessage} onChange={(e) => setReqMessage(e.target.value)} sx={{ mb: 2 }} />
						<Button variant="contained" onClick={submitInventoryRequest} sx={{ width: { xs: '100%', sm: 'auto' }, alignSelf: { xs: 'stretch', sm: 'flex-start' } }}>Submit Request</Button>
						<Typography variant="subtitle1" sx={{ mt: 3, mb: 1 }}>My Requests</Typography>
						{loadingRequests ? (
							<Typography variant="body2" color="text.secondary">Loading requests...</Typography>
						) : myRequests.length === 0 ? (
							<Typography variant="body2" color="text.secondary">No requests yet.</Typography>
						) : (
							<TableContainer component={Paper} variant="outlined" sx={{ overflowX: 'auto' }}>
								<Table size="small" sx={{ minWidth: { xs: 680, sm: 760 } }}>
									<TableHead>
										<TableRow>
											<TableCell>Item</TableCell>
											<TableCell>Quantity</TableCell>
											<TableCell>Work Site</TableCell>
											<TableCell>Notes</TableCell>
											<TableCell>Date Requested</TableCell>
											<TableCell>Status</TableCell>
											<TableCell align="right">Action</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{myRequests.map((r) => {
											const status = String(r.status || 'pending');
											const statusNorm = status.toLowerCase();
											const chipColor = statusNorm === 'approved'
												? 'success'
												: statusNorm === 'rejected'
													? 'error'
													: statusNorm === 'pending'
														? 'warning'
														: 'default';
											return (
												<TableRow key={r.id}>
													<TableCell>{r.item_name || '-'}</TableCell>
													<TableCell>{r.quantity ?? r.requested_quantity ?? '-'}</TableCell>
													<TableCell>{r.branch_code && r.branch_name ? `${r.branch_code} - ${r.branch_name}` : r.branch_code || r.branch_name || r.requested_by_branch_name || currentDeployment?.branch_name || '-'}</TableCell>
													<TableCell>{r.notes || r.message || r.note || '-'}</TableCell>
													<TableCell>{formatDateOnly(r.requested_at || r.request_date || r.date_requested || r.created_at)}</TableCell>
													<TableCell>
														<Chip
															label={status}
															color={chipColor}
															size="small"
															variant={statusNorm === 'cancelled' ? 'outlined' : 'filled'}
														/>
													</TableCell>
													<TableCell align="right">
														<Button
															variant="outlined"
															color="secondary"
															size="small"
															disabled={statusNorm !== 'pending'}
															onClick={() => handleCancelRequest(r.id)}
														>
															CANCEL
														</Button>
													</TableCell>
												</TableRow>
											);
										})}
									</TableBody>
								</Table>
							</TableContainer>
						)}
					</Paper>
				)}

				
					{activeSection === 'inbox' && (
						<Paper sx={{ p: { xs: 1.75, sm: 3 } }}>
							<InboxPanel onUnreadCountChange={setUnreadInboxCount} />
						</Paper>
					)}
{activeSection === 'file-leave' && (
					<Paper sx={{ p: { xs: 1.75, sm: 3 } }}>
						<Typography variant="h5" sx={{ mb: 2 }}>File Leave</Typography>
						<Box sx={{ display: 'grid', gap: 2 }}>
							<LeaveRequestForm
								onSubmitted={fetchMyLeaveRequests}
								onMetaLoaded={handleLeaveMetaLoaded}
								enabled={Boolean(user)}
							/>
							<LeaveBalancesSummary
								balances={leaveBalances}
								leaveTypes={allowedLeaveTypes}
							/>
						</Box>
<Box sx={{ mt: 3 }}>
                        <Typography variant="subtitle1" sx={{ mb: 1 }}>
                          My Leave Requests
                        </Typography>

                        <Paper variant="outlined" sx={{ overflowX: 'auto' }}>
                          <LeaveRequestsTable
                            rows={myLeaveRequests}
                            loading={myLeaveLoading}
                            error={myLeaveError}
                            emptyText="You have no leave requests yet."
                            allowFollowupUpload
                            onAttachmentUploaded={fetchMyLeaveRequests}
                          />
                        </Paper>
                      </Box>
				</Paper>
			)}
{activeSection === 'dtr-upload' && (
					<Paper sx={{ p: { xs: 1.75, sm: 3 } }}>
						<Typography variant="h5" sx={{ mb: 1 }}>Attendance Evidence Upload</Typography>
						<Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
							Upload your attendance evidence photo for validation.
						</Typography>
						<Box sx={{ display: 'grid', gap: 2, maxWidth: 620 }}>
							<Button variant="outlined" component="label" disabled={dtrEvidenceLoading}>
								Choose Evidence Photo
								<input
									type="file"
									accept="image/png,image/jpeg"
									hidden
									onChange={(e) => {
										const nextFile = e.target.files && e.target.files[0] ? e.target.files[0] : null;
										setDtrEvidenceFile(nextFile);
									}}
								/>
							</Button>
							<Alert severity={dtrEvidenceFile ? 'info' : 'warning'} sx={{ py: 0.5 }}>
								{dtrEvidenceFile
									? `Selected file: ${dtrEvidenceFile.name}. Click Submit Evidence Photo to upload it.`
									: 'No evidence photo selected yet. Accepted files: JPG or PNG, up to 10MB.'}
							</Alert>
							<TextField
								label="Notes"
								placeholder="Example: April 2026 DTR, site branch, or cut-off period"
								value={dtrEvidenceNotes}
								onChange={(e) => setDtrEvidenceNotes(e.target.value)}
								multiline
								minRows={2}
								disabled={dtrEvidenceLoading}
							/>
							<Box>
								<Button variant="contained" onClick={submitDtrEvidence} disabled={dtrEvidenceLoading || !dtrEvidenceFile}>
									{dtrEvidenceLoading ? <CircularProgress size={18} /> : 'Submit Evidence Photo'}
								</Button>
							</Box>
						</Box>
						<Box sx={{ mt: 3 }}>
							<Typography variant="subtitle1" sx={{ mb: 1 }}>My Uploaded Attendance Evidence</Typography>
							<Paper variant="outlined" sx={{ overflowX: 'auto' }}>
								<Table size="small">
									<TableHead>
										<TableRow>
											<TableCell>Photo</TableCell>
											<TableCell>Uploaded At</TableCell>
											<TableCell>Notes</TableCell>
											<TableCell>Action</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{dtrEvidenceRows.length === 0 ? (
											<TableRow>
												<TableCell colSpan={4}>No attendance evidence uploaded yet.</TableCell>
											</TableRow>
										) : dtrEvidenceRows.map((row) => (
											<TableRow key={row.id}>
												<TableCell>
													{row.file_url ? (
														<Box component="img" src={row.file_url} alt="DTR evidence" sx={{ width: 88, height: 64, objectFit: 'cover', borderRadius: 1, border: '1px solid #e2e8f0' }} />
													) : '-'}
												</TableCell>
												<TableCell>{row.captured_at ? formatDateTimePH(row.captured_at) : '-'}</TableCell>
												<TableCell>{row.notes || '-'}</TableCell>
												<TableCell>
													{row.file_url ? (
														<Button size="small" variant="outlined" component="a" href={row.file_url} target="_blank" rel="noreferrer">View</Button>
													) : '-'}
												</TableCell>
											</TableRow>
										))}
									</TableBody>
								</Table>
							</Paper>
						</Box>
				</Paper>
			)}
	</Box>
	</Box>

	<Dialog
		open={timeOutDialogOpen}
		onClose={() => setTimeOutDialogOpen(false)}
	>
		<DialogTitle>Confirm Time Out</DialogTitle>
		<DialogContent>
			<Typography>
				Are you sure you want to record a time-out for your current shift?
			</Typography>
		</DialogContent>
		<DialogActions>
			<Button
				onClick={() => setTimeOutDialogOpen(false)}
				disabled={busy}
			>
				Cancel
			</Button>
			<Button
				variant="contained"
				color="error"
				onClick={confirmCustodianTimeOut}
				disabled={busy || !hasOpenShift}
			>
				{busy ? <CircularProgress size={18} /> : 'Confirm Time Out'}
			</Button>
		</DialogActions>
	</Dialog>
	<Dialog
		open={manualReasonDialogOpen}
		onClose={() => {
			if (manualLoading) return;
			setManualReasonDialogOpen(false);
			setManualEvidenceFile(null);
		}}
		maxWidth="sm"
		fullWidth
	>
		<DialogTitle>No-Camera Time In Reason</DialogTitle>
		<DialogContent>
			<Typography sx={{ mb: 1.5 }}>
				Please provide your reason for no-camera time in.
			</Typography>
			<TextField
				autoFocus
				fullWidth
				multiline
				minRows={3}
				placeholder="Type your reason here..."
				value={manualReasonDraft}
				onChange={(e) => setManualReasonDraft(e.target.value)}
				disabled={manualLoading}
			/>
			<Box sx={{ mt: 2 }}>
				<Button variant="outlined" component="label" disabled={manualLoading}>
					Attach Proof Photo
					<input
						type="file"
						accept="image/png,image/jpeg"
						hidden
						onChange={(e) => {
							const nextFile = e.target.files && e.target.files[0] ? e.target.files[0] : null;
							setManualEvidenceFile(nextFile);
						}}
					/>
				</Button>
				<Typography variant="caption" sx={{ display: 'block', mt: 0.75, color: 'text.secondary' }}>
					{manualEvidenceFile ? manualEvidenceFile.name : 'Attach a selfie or DTR proof photo for HR review.'}
				</Typography>
			</Box>
		</DialogContent>
		<DialogActions>
			<Button onClick={() => { setManualReasonDialogOpen(false); setManualEvidenceFile(null); }} disabled={manualLoading}>
				Cancel
			</Button>
			<Button
				variant="contained"
				onClick={() => submitManualRequestWithReason(manualReasonDraft)}
				disabled={manualLoading}
			>
				{manualLoading ? <CircularProgress size={18} /> : 'Submit Request'}
			</Button>
		</DialogActions>
	</Dialog>
	<Dialog
		open={Boolean(isOnBreak)}
		disableEscapeKeyDown
		fullWidth
		maxWidth="sm"
		onClose={() => {}}
	>
		<DialogTitle sx={{ pb: 1 }}>Currently On Break</DialogTitle>
		<DialogContent>
			<Alert severity={breakCountdownMs > 0 ? 'info' : 'warning'} sx={{ mb: 2 }}>
				Your account is paused while you are on break. End your break first before using the rest of your account.
			</Alert>
			<Box
				sx={{
					p: 2,
					borderRadius: 3,
					bgcolor: '#0f172a',
					color: '#fff',
					textAlign: 'center'
				}}
			>
				<Typography variant="caption" sx={{ display: 'block', color: '#cbd5e1', letterSpacing: 0.8 }}>
					BREAK COUNTDOWN
				</Typography>
				<Typography sx={{ fontSize: { xs: 30, sm: 40 }, fontWeight: 800, lineHeight: 1.1, fontFamily: 'monospace', mt: 0.5 }}>
					{breakCountdownLabel}
				</Typography>
			</Box>
			<Box sx={{ mt: 2, display: 'grid', gap: 0.75 }}>
				<Typography variant="body2"><strong>Break started:</strong> {breakStartLabel}</Typography>
				<Typography variant="body2"><strong>Expected return:</strong> {breakReturnLabel}</Typography>
				<Typography variant="body2" color="text.secondary">
					{breakCountdownMs > 0
						? 'End your break when you return to work.'
						: 'Your one-hour break window is over. End your break now to continue working.'}
				</Typography>
			</Box>
		</DialogContent>
		<DialogActions sx={{ px: 3, pb: 3 }}>
			<Button variant="contained" disabled={busy} onClick={endCustodianBreak}>
				{busy ? <CircularProgress size={18} /> : 'End Break'}
			</Button>
		</DialogActions>
	</Dialog>
	<MyProfileDialog open={profileOpen} onClose={() => setProfileOpen(false)} user={user} />
	</React.Fragment>
);
}
